import { render, staticRenderFns } from "./ResultScreen.vue?vue&type=template&id=28174ebc&scoped=true&lang=pug&"
import script from "./ResultScreen.vue?vue&type=script&lang=ts&"
export * from "./ResultScreen.vue?vue&type=script&lang=ts&"
import style0 from "./ResultScreen.vue?vue&type=style&index=0&id=28174ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28174ebc",
  null
  
)

export default component.exports